import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const TeamAdminPlayerMapping = () => (
  <Wrap>
    <h1>Player mapping</h1>
    <Body>
      Players are mapped to user accounts through the invitation flow. Open{' '}
      <Link to="/team-admin/players">Roster</Link> and click <strong>Invite player</strong> —
      the recipient accepts the magic-link invitation to create their account
      and complete the mapping.
    </Body>
  </Wrap>
);

export default TeamAdminPlayerMapping;

const Wrap = styled.div`padding: 24px; max-width: 720px; margin: 0 auto;`;
const Body = styled.p`color: ${(p) => p.theme.blueish2}; line-height: 1.6; a { color: ${(p) => p.theme.green}; }`;
